import { InjectionToken } from '@angular/core';

export type AiAssistantConfig = {
  triggerWorkflowEndpoint: string;
  checkWorkflowStatusEndpoint: string;
  chatEndpoint: string;
};

export const AI_ASSISTANT_CONFIG = new InjectionToken<AiAssistantConfig>(
  'aiAssistantConfig',
);
